// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.expand = ["properties"];
});
